import React, { useEffect, useState, useContext } from 'react';
import styles from './ExpiredProducts.module.css';
import lineTableItems from '../../assets/line_table_items.svg';
import ArrowBelow from '../../assets/arrow_below.svg';

import { getExpiredProductsByStoreId } from "../../hooks/ExpiredProduct";
import { ExpiredProductContext } from '../../context/ExpiredProductContext';
import { StoresContext } from '../../context/StoresContext';
import { AuthContext } from '../../context/AuthContext';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const ExpiredProducts = () => {

    const { researchExpiredProducts } = useContext(ExpiredProductContext);
    const { setStore } = useContext(StoresContext);
    const { user } = useContext(AuthContext);

    const [expiredProducts, setExpiredProducts] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(50);
    const [totalItems, setTotalItems] = useState(0);

    useEffect(() => {
        if(user != null || user !== undefined) {
            setStore(user.stores[0])
            fetchExpiredProductsByStoreId(user.stores[0].id, currentPage, itemsPerPage);
        }
        
    }, [currentPage]);


    useEffect(() => {
        if(researchExpiredProducts !== undefined && researchExpiredProducts?.length > 0) {
            setExpiredProducts(researchExpiredProducts)
        }else {
            if(user !== null || user !== undefined) {
                fetchExpiredProductsByStoreId(user.stores[0].id, currentPage, itemsPerPage);
            }
        }
      
    },[researchExpiredProducts])


    const fetchExpiredProductsByStoreId = async (storeId, page, limit) => {
        try {
            const expiredProductData = await getExpiredProductsByStoreId(storeId, page, limit);
            if (expiredProductData) {
                setExpiredProducts(expiredProductData.data.data);
                setTotalItems(expiredProductData.data.totalItems || 0);
            } else {
                setExpiredProducts([]);
            }
        } catch (error) {
            console.error("Erro ao buscar produtos:", error);
            setExpiredProducts([]);
        }
    };


    const handlePreviousPage = () => {
        setCurrentPage((prev) => Math.max(prev - 1, 1));
    };


    const handleNextPage = () => {
        setCurrentPage((prev) => Math.min(prev + 1, Math.ceil(totalItems / itemsPerPage)));
    };


    return (
        <div className={styles.container}>
            <ToastContainer />
            <div className={styles.infoLine}>
                <img src={ArrowBelow} alt="Seta para baixo" />
                <h4 className={styles.headerInfo}>Tabela de Produtos</h4>
                <img className={styles.lineTableItems} src={lineTableItems} alt="Linha" />


                <div className={styles.pagination}>
                    <button onClick={handlePreviousPage} disabled={currentPage === 1}>
                        {"<"}
                    </button>
                    <span>
                        {(currentPage - 1) * itemsPerPage + 1}-{Math.min(currentPage * itemsPerPage, totalItems)} de {totalItems}
                    </span>
                    <button onClick={handleNextPage} disabled={currentPage === Math.ceil(totalItems / itemsPerPage)}>
                        {">"}
                    </button>
                </div>
            </div>

            
            <div className={styles.tableItems}>
            <table>
                <thead>
                    <tr>
                        <th><div className={styles.scrollableHeader}>Id</div></th>
                        <th><div className={styles.scrollableHeader}>Código de Barras</div></th>
                        <th><div className={styles.scrollableHeader}>Nome do Produto</div></th>
                        <th><div className={styles.scrollableHeader}>Fabricante</div></th>
                        <th><div className={styles.scrollableHeader}>Grupo</div></th>
                        <th><div className={styles.scrollableHeader}>Quantidade</div></th>
                        <th><div className={styles.scrollableHeader}>Lote</div></th>
                        <th><div className={styles.scrollableHeader}>Data de validade</div></th>
                        <th><div className={styles.scrollableHeader}>Dias a vencer</div></th>
                        <th><div className={styles.scrollableHeader}>Vendido</div></th>
                        <th><div className={styles.scrollableHeader}>Saldo</div></th>
                        <th><div className={styles.scrollableHeader}>Localização</div></th>
                        <th><div className={styles.scrollableHeader}>Colaborador</div></th>
                    </tr>
                </thead>
                <tbody>
                    { (expiredProducts).map((expiredProduct) => (
                        <tr key={expiredProduct.id}>
                            <td>{expiredProduct.id}</td>
                            <td>{expiredProduct.product.barcode}</td>
                            <td>{expiredProduct.product.name}</td>
                            <td>{expiredProduct.product.manufacturer}</td>
                            <td>{expiredProduct.product.group}</td>
                            <td>{expiredProduct.quantity}</td>
                            <td>{expiredProduct.lot}</td>
                            <td>{expiredProduct.expirationDate}</td>
                            <td>{expiredProduct.daysToExpire}</td>
                            <td>{expiredProduct.quantitySold}</td>
                            <td>{expiredProduct.balance}</td>
                            <td>{expiredProduct.location}</td>
                            <td>{expiredProduct.user.name}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    </div>
    );
};

export default ExpiredProducts;